import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useLocalizedNavigation } from "../../hooks/useLocalizedNavigation";

export const HeaderDesktopNav = () => {
  const { t } = useTranslation("header");
  const { localizePath } = useLocalizedNavigation();
  const isSnapshot =
    typeof navigator !== "undefined" && navigator.userAgent === "ReactSnap";

  const navItems = [
    { name: t("products"), link: "products" },
    { name: t("aboutUs"), link: "aboutus" },
    { name: t("downloadArea"), link: "downloadarea" },
    { name: t("recruitment"), link: "recruitment" },
    { name: t("contacts"), link: "contacts" },
    { name: t("news"), link: "news" },
  ].filter((item) => !(isSnapshot && item.link === "recruitment"));

  return (
    <div className="header__list header__desktop">
      {navItems.map((item) => (
        <Link key={item.link} to={localizePath(`/${item.link}`)}>
          <li className="header__link">{item.name}</li>
        </Link>
      ))}
    </div>
  );
};
